import { Users } from "lucide-react";

export const familiesLabel = (n) => `${n} ${n === 1 ? "family" : "families"}`;

export const CountLine = ({ count, testId, className = "" }) => {
  if (!count) return null;
  return (
    <p data-testid={testId} className={`flex items-center gap-2 text-sm font-medium ${className}`}>
      <Users className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>Join {familiesLabel(count)} already waiting</span>
    </p>
  );
};
